module.exports = __webpack_public_path__ + "img/office-de-tourisme.209bede6.jpg";